import React from "react";
import AuthContext from "store/AuthContext";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';

import 'swiper/swiper-bundle.css';
import './HomeSlider.css';

interface SlideInfo {
    image: string;
    title: string;
    description: string;
    button: {
        text: string;
        link: string;
    }
}

interface SliderData {
    slides: SlideInfo[];
}

const SliderItem: React.FC<{dimension: string, slide: SlideInfo}> = ({dimension, slide}) => {
    const authCtx = React.useContext(AuthContext);
    const navigate = useNavigate();
    const divStyle = {
        backgroundImage: slide.image ? `url(${authCtx.makeFileUrl(dimension, slide.image)})` : undefined,
    };

    const onClick = () => {
        navigate(`/dimension?dim=${dimension}`);
    }

    return (
        <div className="home-slider-item-container"  style={divStyle}
             onClick={onClick}>

            <div className="home-slider-item-inside-container">
                <h2 className='home-slider-item-title'>{slide.title}</h2>
                <h4 className='home-slider-item-description'>{slide.description}</h4>
                <Button className="btn btn-light">{slide.button.text}</Button>
            </div>
            <img src={authCtx.makeFileUrl(dimension, 'icon.png')} alt="icon" className="home-slider-icon" />
        </div>
    )

}

const HomeSlider: React.FC<{dimension?: string}> = ({dimension}) => {
    const authCtx = React.useContext(AuthContext);
    const [data, setData] = React.useState<SliderData | null>(null);

    React.useEffect(() => {
        refreashSlider();
    }, [dimension]);

    const refreashSlider = async () => {
        if (!dimension) {
            return;
        }
        try {
            const response = await fetch(authCtx.makeFileUrl(dimension, 'slider.json'), {cache: "no-cache"});
            const data: SliderData = await response.json();
            if (!data || !data.slides || data.slides.length === 0) {
                console.warn(`No slides found for dimension: ${dimension} - [${JSON.stringify(data)}]`);
                return;
            }
            setData(data);
        } catch(error) {
            console.error(`Get home slider error: ${error}`);
        }
    }

    if (!data || data.slides.length === 0) {
        return null;
    }

    return (
        <div className='home-slider-container'>
            <Swiper modules={[Pagination, Autoplay]}
                    slidesPerView={1}
                    loop={true}
                    //autoplay={{ delay: 5000, disableOnInteraction: true }}
                    pagination={{ clickable: true }}
                >
                    {data.slides.map((item, idx) => {
                        return (
                            <SwiperSlide key={idx}>
                                <SliderItem dimension={dimension!} slide={item}/>
                            </SwiperSlide>
                        )
                    })}
            </Swiper>
        </div>
    );
}

export default HomeSlider;
